export default __webpack_public_path__ + "static/media/0x5668f6d40e15188045a1de6295054103c13ffac1.10424e4e.webp";